export var config = globalThis;
